import React, {Component} from 'react';
import PropTypes from 'prop-types';
import JobInputTitle from './JobInputTitle';
import Toggle from 'material-ui/Toggle';

const jobBooleanInputStyles = {
    container: {margin: '0 0 1em 0'},
    label: {marginLeft: 16},
    thumbOff: {backgroundColor: '#999999'},
    trackOff: {backgroundColor: '#f0f0f0'},
    thumbOn: {backgroundColor: '#1478b9'}
}

class JobBooleanInput extends Component {

    handleToggle = (e, isChecked) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(this.props.customType, this.props.name, isChecked);
        }
    };

    render() {
        const {
            customType,
            defaultValue,
            label,
            param,
            style,
            tooltip
        } = this.props;

        return (
            <div style={jobBooleanInputStyles.container}>
                <JobInputTitle label={label} tooltip={tooltip}/>

                <Toggle
                    key={`job-report-param-${customType}-${param}`}
                    label={label}
                    labelPosition="right"
                    labelStyle={jobBooleanInputStyles.label}
                    style={style}
                    thumbStyle={jobBooleanInputStyles.thumbOff}
                    thumbSwitchedStyle={jobBooleanInputStyles.thumbOn}
                    trackStyle={jobBooleanInputStyles.trackOff}
                    defaultToggled={defaultValue}
                    onToggle={this.handleToggle}
                />
            </div>
        )
    }
}

JobBooleanInput.propTypes = {
    customType: PropTypes.string,
    defaultValue: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    nativeType: PropTypes.string,
    onChange: PropTypes.func,
    param: PropTypes.string,
    required: PropTypes.bool,
    style: PropTypes.object,
    tooltip: PropTypes.string,
    value: PropTypes.number
};

JobBooleanInput.defaultProps = {
    name: 'active',
    param: 'active',
    nativeType: 'bool',
    required: false,
    style: {}
};

export default JobBooleanInput;



// WEBPACK FOOTER //
// ./src/Fuse/components/JobBooleanInput.js